import React from 'react';

import { formatCardNumber } from '@eika-infrastruktur/format';
import { AccountBalance } from '@eika-kortbetjening/types';
import { RowButton } from '@eika/button';
import { ErrorCard, WarningCard } from '@eika/card';
import { IconTypes } from '@eika/icon';

import { Format } from '@/domain/app';
import piwik from '@/piwik/piwik';

import { Card } from '@generated-types';
import { KortbetjeningText } from '@hooks/use-text';

interface Props {
    cardList?: Card[];
    text: KortbetjeningText;
    loadingError: boolean;
    onClick: (card: Card) => void;
    accountBalance: AccountBalance;
}

const CardAccountList: React.FC<Props> = ({ cardList, accountBalance, text, loadingError, onClick }) => {
    if (loadingError) {
        return (
            <ErrorCard
                data-track-id={piwik.transfer.transferFetchAccountsFail.dataTrackId}
                data-track-linkname={piwik.transfer.transferFetchAccountsFail.dataTrackLinkname}
                description={text.transferFromErrorDescription}
                icon={IconTypes.BANDAGED_HEART}
                id={piwik.transfer.transferFetchAccountsFail.dataTrackId}
                isModal
                title={text.messageErrorUps}
            />
        );
    }

    if (cardList && cardList.length) {
        const { balance, limit } = accountBalance;
        return (
            <ul className="select-list__container">
                {cardList.map((card) => (
                    <li key={card.accountNumber}>
                        <RowButton
                            aria-label="velg konto"
                            className="account-list-item__container"
                            data-track-id={piwik.transfer.transferCardAccountOptions.dataTrackId}
                            data-track-linkname={piwik.transfer.transferCardAccountOptions.dataTrackLinkname}
                            id={piwik.transfer.transferCardAccountOptions.dataTrackId}
                            onClick={() => onClick(card)}
                        >
                            <span className="account-list-item__left-col-second-row">{card.type}</span>
                            <span className="account-list-item__left-col-third-row">{formatCardNumber(card.id)}</span>
                            {balance ? (
                                <span className="account-list-item__right-col-second-row">
                                    {Format.amount(balance, 2, true)}
                                </span>
                            ) : (
                                <></>
                            )}
                            {limit ? (
                                <span className="account-list-item__right-col-third-row">
                                    {Format.amount(-Math.abs(limit), 0, true)}
                                </span>
                            ) : (
                                <></>
                            )}
                        </RowButton>
                    </li>
                ))}
            </ul>
        );
    }

    return (
        <WarningCard isModal title={text.transferFromWarningTitle}>
            {text.transferFromWarningDescription}
        </WarningCard>
    );
};

export default CardAccountList;
